/* ============================================================
   CULTURA SUBSCRIBER PORTAL — script
   Loaded at the end of templates/page.subscriber-portal.liquid.
   ============================================================ */

(function () {
  'use strict';

  /* ──────────────────────────────────────────────────────────
     VIEW SWITCHING
     Rail links carry `data-view`; main panels carry
     `data-view-panel`. Clicking a rail link flips both,
     updates the URL hash, and scrolls to the top.
     ────────────────────────────────────────────────────────── */
  var viewLinks = document.querySelectorAll('[data-view]');
  var viewPanels = document.querySelectorAll('[data-view-panel]');

  function switchView(name) {
    var matched = false;
    viewPanels.forEach(function (panel) {
      var active = panel.getAttribute('data-view-panel') === name;
      panel.classList.toggle('is-active', active);
      if (active) matched = true;
    });
    viewLinks.forEach(function (link) {
      link.classList.toggle('is-active', link.getAttribute('data-view') === name);
    });
    return matched;
  }

  viewLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var name = link.getAttribute('data-view');
      if (!name) return;
      switchView(name);
      if (history.replaceState) {
        history.replaceState(null, '', '#' + name);
      } else {
        window.location.hash = name;
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  // Initial view — priority:
  //   1. feedback-success marker (Shopify form post-back)
  //   2. URL hash
  //   3. default to "home"
  var initialView;
  if (document.querySelector('[data-feedback-success]')) {
    initialView = 'feedback';
  } else {
    initialView = (window.location.hash || '#home').replace('#', '') || 'home';
  }
  if (!switchView(initialView)) switchView('home');

  // Handle hash changes (back/forward navigation)
  window.addEventListener('hashchange', function () {
    var name = window.location.hash.replace('#', '') || 'home';
    switchView(name);
  });

  /* ──────────────────────────────────────────────────────────
     BREW TOGGLE — swap Filter ⇄ Espresso panels per coffee.
     ────────────────────────────────────────────────────────── */
  document.querySelectorAll('.cr-brew-toggle__pill').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('.cr-brew-card');
      if (!card) return;

      card.querySelectorAll('.cr-brew-toggle__pill').forEach(function (p) {
        p.classList.remove('is-active');
      });
      card.querySelectorAll('.cr-brew-panel').forEach(function (p) {
        p.classList.remove('is-active');
      });

      btn.classList.add('is-active');
      var target = card.querySelector('#' + btn.getAttribute('data-target'));
      if (target) target.classList.add('is-active');
    });
  });

  /* ──────────────────────────────────────────────────────────
     IN-VIEW ANCHOR SCROLL — for links that aren't view
     switchers (e.g., coffee sub-nav pills). Smooth-scrolls to
     the target within the current view.
     ────────────────────────────────────────────────────────── */
  document.querySelectorAll('a[href^="#"]:not([data-view])').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (!href || href === '#') return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
